import * as t from 'io-ts';
import { authorizedTo, id, meta } from '@/services/api';

const data = t.type({
  label: t.string,
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});
